window.HegydGtm = {

    pushToDatalayer : function (gtm) {
        if(typeof dataLayer !== 'undefined' && gtm !== undefined ) {
            // Envoi des données à GTM
            Object.keys(gtm).forEach(function(k){
                dataLayer.push(gtm[k]);
            });
        }
    },

    /**
     * Chargement des data-* pour envoyer l'event productClick dès qu'un produit est cliqué
     * Exclusion des liens ".product-item a" qui ont la classe ".btn-add-cart" (btn ajout au panier)
     */
    initEventProductClick : function(){
        $("body").on("click",".product-item a:not(.btn-add-cart)",function (e) {
            e.preventDefault();
            var $this = $(this);
            var $productCard = $this.parents(".product-item");
            var productUrl = $this.attr("href");
            var productObject;

            if( $productCard !== undefined && $productCard.length
                && ( productObject = $productCard.data("product") ) ){
                // Initialisation du nom de la liste concernées
                var listName = "Products list";
                if ( $productCard.data("list-name") !== undefined ) {
                    listName = $productCard.data("list-name");
                }
                HegydGtm.pushEventProductClick(productObject, productUrl, listName);
            } else {
                document.location = productUrl;
            }
        });
    },

    /**
     * Transmission de l'event productClick à partir des données objet transmise sur la vignette produit
     *
     * @param productObj Objet json du produit avec les informations de base (nom, id, prix, ... )
     * @param productUrl URL catchée vers la page suivante (page produit)
     * @param listName   Nom de la liste courante contenant le produit, surchargeable
     */
    pushEventProductClick : function(productObj, productUrl, listName) {
        if( typeof dataLayer !== "undefined" ) {
            listName = typeof listName !== "undefined" ? listName : "Products list";
            dataLayer.push({
                'event': 'productClick',
                "eventCategory": "Ecommerce",
                "eventAction": "Clic",
                "eventLabel": productObj.name,
                'ecommerce': {
                    'click': {
                        'actionField': {'list': listName},      // Optional list property.
                        'products': [{
                            'name': productObj.name,            // Name or ID is required.
                            'id': productObj.id,
                            'price': productObj.price,
                            'brand': productObj.brand,
                            'category': productObj.category,
                            'variant': productObj.variant,
                            'position': productObj.position
                        }]
                    }
                },
                'eventCallback': function () {
                    document.location = productUrl;
                }
            });
        } else {
            // En cas d'absence de datalayer, on redirige vers la page produit quoi qu'il en soit
            document.location = productUrl;
        }
    },

    initEvents: function () {
        HegydGtm.initEventProductClick();
    },

    init: function () {
        HegydGtm.initEvents();
    }
};

(function ($) {
    HegydGtm.init();
})(jQuery);
